import { render, staticRenderFns } from "./UserAdmin.vue?vue&type=template&id=f013d922"
import script from "./UserAdmin.vue?vue&type=script&lang=js"
export * from "./UserAdmin.vue?vue&type=script&lang=js"
import style0 from "./UserAdmin.vue?vue&type=style&index=0&id=f013d922&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports